import API from "Common/Client/endpoint";
import api from "Common/Client/Interceptor";

export const fetchManagerDashboard = async (token) => {
  try {
    const response = await api.get(API.dashboard.managerDashboard);
    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    throw error;
  }
};